import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class EventService {

  @Output() permissionsLoadedEvent: EventEmitter<object> = new EventEmitter<object>();

  firePermissionsLoadedEvent() {
    this.permissionsLoadedEvent.emit();
  }
}